import React from 'react'
import { Bubble, ListSection } from '../common'

const WishlistItem = (props) =>{
    return (
        <div className='container flex flex-col'>
            <a href={props.url} target="_blank" rel="noreferrer" className='flex'>
                <img src={props.img} alt={props.nameItem} className='bg-white p-2 xl:p-4 2xl:p-6 border-4 xl:border-8 2xl:border-12 border-stone-300 dark:border-stone-400 rounded-3xl min-w-full aspect-square object-contain' />
            </a>

            <div className='mt-2 xl:mt-4 2xl:mt-6 text-xs xl:text-lg 2xl:text-xl text-center dark:text-stone-200'>{props.nameItem}</div>
        </div>
    )
}

const CategoryItem = (props) => {
    return(
        <Bubble>
            <div className='dark:text-white xl:text-2xl 2xl:text-3xl '>{props.name}</div>
            <div className='mt-2 xl:mt-4 2xl:mt-6 grid grid-cols-3 justify-between justify-items-center gap-3 xl:gap-6 2xl:gap-9'>
                {props.items.map((item) => (
                    <WishlistItem key={item.url} {...item} />
                ))}
            </div>
        </Bubble>
    )
}

export const WishList = (props) => {
    const title = "WISHLIST"
    const description = "To keep track of the things I need:"

    return (
    <ListSection title={title} description={description}>
        <div className='flex flex-col gap-4 xl:gap-10 2xl:gap-16 justify-between mt-2 xl:grid xl:grid-cols-2'>
            {props.wishlists.map((category) => (<CategoryItem key={category.name} {...category}/>))}
        </div>  
    </ListSection>
  )
}
